import { observer } from 'mobx-react';
import * as React from 'react';
import ActionMenu from '../../../../ActionMenu';
import ModalStore from '../../../../Modal/Store';
import ShareButton from '../../../LearningCollection/Share/ShareButton';
import ShareOptionsModal from '../../../LearningCollection/Share/ShareOptionsModal';
import { LearningCollectionSummaryResource } from '../../../Types';
import CloneStore from '../Clone/Store';
import CollaboratorAccessStore from '../CollaboratorAccess/Store';
import LearningCollectionStore from '../Store';
import { actionItems } from './ActionItems';
import Names from './Names';
import PublishedAtStatus from './PublishedAtStatus';

interface Props {
  learningCollectionSummaryResource: LearningCollectionSummaryResource;
  hideModalStore: ModalStore;
  shareModalStore: ModalStore;
  cloneStore: CloneStore;
  collaboratorAccessStore: CollaboratorAccessStore;
  learningCollectionStore: LearningCollectionStore;
  index?: number;
  totalLength?: number;
}

const Header: React.FC<Props> = ({
  learningCollectionSummaryResource,
  hideModalStore,
  shareModalStore,
  cloneStore,
  collaboratorAccessStore,
  learningCollectionStore,
  index,
  totalLength,
}) => {
  const { id, name, internalName, publishedAt } = learningCollectionSummaryResource.payload;
  const { links } = learningCollectionSummaryResource;

  const [isInviteModalOpen, setIsInviteModalOpen] = React.useState(false);

  // Check if this is the first item (index equals totalLength when provided)
  const isFirstItem = index !== undefined && totalLength !== undefined && index === totalLength;
  const intercomTarget = isFirstItem ? 'First collection action menu' : 'Collection action menu';
  const shareIntercomTarget = isFirstItem
    ? 'first-collection-share-button'
    : 'collection-share-button';

  return (
    <>
      <div className="relative flex items-center justify-between">
        <div className="flex items-center">
          <PublishedAtStatus publishedAt={publishedAt} />
          <Names name={name} internalName={internalName} id={id} />
        </div>
        <div className="flex items-center gap-4">
          <ShareButton
            onClick={() => setIsInviteModalOpen(true)}
            collectionLinks={links}
            intercomTarget={shareIntercomTarget}
          />
          <ActionMenu intercomTarget={intercomTarget}>
            {actionItems({
              id,
              name,
              shareModalStore,
              hideModalStore,
              cloneStore,
              collaboratorAccessStore,
              links,
            })}
          </ActionMenu>
        </div>
      </div>
      {isInviteModalOpen && (
        <ShareOptionsModal
          close={() => setIsInviteModalOpen(false)}
          collectionId={id}
          publishedAt={publishedAt}
          onPublishSuccess={(newPublishedAt) => {
            learningCollectionSummaryResource.payload.publishedAt = newPublishedAt;
          }}
        />
      )}
    </>
  );
};

export default observer(Header);
